var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreferenceHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3.33337H2.5",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 15.8334H2.5",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 15.8334C17.5003 15.8334 12.9687 15.8334 11.667 15.8334",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 9.58337H9.16699",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 3.33337H13.333",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.58337H2.5",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.083 1.66663C12.4713 1.66663 12.6654 1.66663 12.8186 1.73006C13.0228 1.81463 13.185 1.97687 13.2696 2.18106C13.333 2.3342 13.333 2.52834 13.333 2.91663V3.74996C13.333 4.13824 13.333 4.33238 13.2696 4.48553C13.185 4.68972 13.0228 4.85195 12.8186 4.93653C12.6654 4.99996 12.4713 4.99996 12.083 4.99996C11.6948 4.99996 11.5006 4.99996 11.3474 4.93653C11.1433 4.85195 10.981 4.68972 10.8964 4.48553C10.833 4.33238 10.833 4.13824 10.833 3.74996V2.91663C10.833 2.52834 10.833 2.3342 10.8964 2.18106C10.981 1.97687 11.1433 1.81463 11.3474 1.73006C11.5006 1.66663 11.6948 1.66663 12.083 1.66663Z",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 14.1666C10.8052 14.1666 10.9994 14.1666 11.1526 14.23C11.3567 14.3146 11.519 14.4769 11.6036 14.681C11.667 14.8342 11.667 15.0284 11.667 15.4166V16.25C11.667 16.6382 11.667 16.8324 11.6036 16.9855C11.519 17.1897 11.3567 17.352 11.1526 17.4365C10.9994 17.5 10.8052 17.5 10.417 17.5C10.0287 17.5 9.83458 17.5 9.68141 17.4365C9.47724 17.352 9.31499 17.1897 9.23041 16.9855C9.16699 16.8324 9.16699 16.6382 9.16699 16.25V15.4166C9.16699 15.0284 9.16699 14.8342 9.23041 14.681C9.31499 14.4769 9.47724 14.3146 9.68141 14.23C9.83458 14.1666 10.0287 14.1666 10.417 14.1666Z",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 7.91663C8.30528 7.91663 8.49941 7.91663 8.65258 7.98006C8.85674 8.06463 9.01899 8.22687 9.10358 8.43104C9.16699 8.58421 9.16699 8.77838 9.16699 9.16663V9.99996C9.16699 10.3882 9.16699 10.5824 9.10358 10.7355C9.01899 10.9397 8.85674 11.102 8.65258 11.1865C8.49941 11.25 8.30528 11.25 7.91699 11.25C7.52871 11.25 7.33457 11.25 7.18143 11.1865C6.97723 11.102 6.815 10.9397 6.73043 10.7355C6.66699 10.5824 6.66699 10.3882 6.66699 9.99996V9.16663C6.66699 8.77838 6.66699 8.58421 6.73043 8.43104C6.815 8.22687 6.97723 8.06463 7.18143 7.98006C7.33457 7.91663 7.52871 7.91663 7.91699 7.91663Z",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferenceHorizontal);
export default __webpack_public_path__ + "static/media/preference-horizontal.9fa164a5377858a70ac4b7702ed85fe3.svg";
export { ForwardRef as ReactComponent };